// The specialist sign-in and dashboard API on the BossDrop backend
// (backend/server/specialists). A session is an httpOnly cookie on the API's
// own host, so every call sends credentials and nothing here can read it.
import { API_BASE } from "./booking/bookingApi";

async function call(path, { method = "GET", body } = {}) {
  try {
    const res = await fetch(`${API_BASE}${path}`, {
      method,
      credentials: "include",
      ...(body ? { headers: { "Content-Type": "application/json" }, body: JSON.stringify(body) } : {}),
    });
    let data = {};
    try {
      data = (await res.json()) || {};
    } catch {}
    return { status: res.status, ok: res.ok && data.ok !== false, data };
  } catch {
    return { status: 0, ok: false, data: { error: "network" } };
  }
}

export const sendLoginLink = (email) => call("/api/specialists/login", { method: "POST", body: { email } });
export const finishLogin = (token) => call("/api/specialists/login/verify", { method: "POST", body: { token } });
export const signOut = () => call("/api/specialists/logout", { method: "POST", body: {} });
export const loadDashboard = () => call("/api/specialists/me");
export const registerCompany = ({ company, contactName, contactEmail }) =>
  call("/api/specialists/introductions", { method: "POST", body: { company, contactName, contactEmail } });

const USD = new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" });
export const money = (cents) => USD.format(Number(cents || 0) / 100);

const LONG = new Intl.DateTimeFormat("en-US", { month: "short", day: "numeric", year: "numeric", timeZone: "UTC" });
/** "Nov 3, 2026" from a stored day or timestamp, read in UTC so a day never shifts. */
export function day(value) {
  if (!value) return "";
  const ms = Date.parse(String(value).length === 10 ? `${value}T00:00:00Z` : value);
  return Number.isFinite(ms) ? LONG.format(ms) : "";
}

export const STATUS_LABELS = Object.freeze({
  registered: "Waiting for Eric",
  confirmed: "Confirmed and held for you",
  declined: "Declined",
  demo: "Demo booked",
  pilot: "In pilot",
  customer: "Paying customer",
  lost: "Not moving forward",
  lapsed: "Lapsed",
});

// Where a company stands, at a glance: moving, waiting on Eric, or closed.
export const STATUS_TONES = Object.freeze({
  registered: "specialistCream",
  confirmed: "specialistGood",
  demo: "specialistGood",
  pilot: "specialistGood",
  customer: "specialistGood",
  declined: "specialistBad",
  lost: "specialistBad",
  lapsed: "specialistBad",
});

// Money reads green, and red when it's a refund or a correction.
export const moneyTone = (cents) => (Number(cents) > 0 ? "specialistGood" : Number(cents) < 0 ? "specialistBad" : "");

// Words for what the API can refuse, never a raw code.
export const REGISTER_ERRORS = Object.freeze({
  company_required: "Add the company's name.",
  contact_email_invalid: "Check the contact's email address.",
  not_active: "Your agreement has ended, so you can't register new companies.",
  closed_before: "That company was closed on an earlier registration of yours. Talk to Eric if something has changed.",
  rate_limited: "That's a lot of registrations for one hour. Please try again later.",
  network: "Couldn't reach BossDrop. Check your connection and try again.",
});
